import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { NavService } from '../_services/NavService.service';

@Component({
  selector: 'app-pickup-assign',
  templateUrl: './pickup-assign.component.html',
  styleUrls: ['./pickup-assign.component.scss']
})
export class PickupAssignComponent implements OnInit {

  PickupData: any = {};
  PickupId: any = '';

  constructor(
    private commonService: CommonService,
    private _appService: appService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private _navService: NavService,
    private cookieService: CookieService,
    private _activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.PickupId = this._activatedRoute.snapshot.queryParams["pickupId"];
      if (this.PickupId !== undefined && this.PickupId !== null) {
        this.GetpickupreqByNo();
      }
    });
  }

  GetpickupreqByNo() {
    this._appService
      .GetById("PickupRequest", "GetpickupreqByNo", this.PickupId)
      .subscribe(
        (response) => {
          this.PickupData = response.Table[0];

          console.log(this.PickupData);
          console.log(response)
        })
  }

}
